import { Link, useLocation } from "react-router-dom";
import "./home.css";
import parse from "html-react-parser";
import TopStories from "../../components/home/TopStories";

const HomePage = ({ posts, lastPostRef }) => {
  // Helper to truncate text
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };
  const location = useLocation();

  const cat = useLocation().search.split("=")[1];
  const top = useLocation().pathname.split("/")[1];

  return (
    <>
      {!cat && !top && <TopStories />}
      <div className="home">
        <h3
          style={{
            width: "100%",
            textAlign: "center",
            marginBottom: "50px",
            marginTop: "0",
          }}
        >
          {cat
            ? posts[0]?.cat.toUpperCase()
            : top
              ? "Top Stories"
              : "All Stories"}
        </h3>
        {posts.map((post, index) => {
          const isLong = post.desc && post.desc.length > 220;
          const displayedDesc = isLong
            ? truncateText(post.desc, 220)
            : post.desc;
          const vidurl = post.vid.split("=")[1];

          return (
            <Link style={{ marginTop: "0px" }} to={`/post/${post.id}`}>
              <div
                className="card"
                key={post.id}
                ref={index === posts.length - 1 ? lastPostRef : null}
              >
                <h5 className="title">
                  {post.title} {top}
                </h5>

                {post.img && (
                  <div className="img">
                    <img src={post.img} alt="" />
                  </div>
                )}

                {post.vid && (
                  <p
                    style={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    {/* <a href={post.vid} target="_blank">
                          {" "}
                          <img
                            style={{
                              width: "100%",
                              height: "auto",
                              margin: "auto",
                            }}
                            src={`https://img.youtube.com/vi/${vidurl}/maxresdefault.jpg`}
                            alt=""
                          />
                        </a> */}
                    <iframe
                      width="100%"
                      height="315"
                      src={`https://www.youtube.com/embed/${vidurl}?si=MzsWsfe6CARVCQgF`}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </p>
                )}

                {post.desc && (
                  <>
                    <p className="desc">{parse(displayedDesc)}</p>
                    {/* <Link style={{ marginTop: "-30px" }} to={`/post/${post.id}`}>
                    Read More
                  </Link> */}
                  </>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default HomePage;
